module.exports = __webpack_public_path__ + "img/1.57a928c0.png";